import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import * as Sentry from "@sentry/angular";

const PII_HEADER_DENYLIST = ['forwarded', '-ip', 'remote-', 'via', '-user'];

Sentry.init({
  dsn: "https://b0cf6309173ebbc1a59c92faa9c88272@o4509333109735424.ingest.de.sentry.io/4509333319385168",
  // Sentry 11 collects broadly unless told otherwise; this keeps the v10 sendDefaultPii:false baseline.
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpHeaders: {
      request: { deny: PII_HEADER_DENYLIST },
      response: { deny: PII_HEADER_DENYLIST },
    },
    httpBodies: [],
  },
  integrations: [
    Sentry.browserTracingIntegration()
  ],
  // Tracing
  tracesSampleRate: 0.1, // Capture 10% of the transactions
  // Distributed tracing headers go only to our own ccTLD hosts (see COUNTRY_CONFIG)
  // plus localhost for dev serve.
  tracePropagationTargets: ["localhost", /^https:\/\/(www\.)?aposmart\.(se|de|no|dk|ee|co\.uk)\//],
});


if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
